'use client';

import { useState } from 'react';

interface MockTestConfigModalProps {
    isOpen: boolean;
    onClose: () => void;
    onStart: (minutes: number) => void;
}

const DURATIONS = [5, 10, 15, 20, 25, 30] as const;

export default function MockTestConfigModal({ isOpen, onClose, onStart }: MockTestConfigModalProps) {
    const [minutes, setMinutes] = useState<number>(10);

    if (!isOpen) return null;

    const itemsPerComponent = minutes * 3; // minutes * 60 / 5 components / 4 sec per item

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
                <div className="p-6 space-y-6">
                    <h2 className="text-2xl font-semibold text-slate-800">Configure Mock Test</h2>
                    <p className="text-slate-600">Choose total duration for the full mock session. Order: Reasoning → Perceptual Speed → Number Speed & Accuracy → Word Meaning → Spatial Visualization.</p>

                    <div>
                        <div className="grid grid-cols-3 gap-3">
                            {DURATIONS.map((m) => (
                                <button
                                    key={m}
                                    onClick={() => setMinutes(m)}
                                    className={`px-3 py-2 rounded-lg border ${minutes === m ? 'bg-blue-500 text-white border-blue-600' : 'bg-white text-slate-700 border-slate-300 hover:border-blue-400'}`}
                                >
                                    {m} min
                                </button>
                            ))}
                        </div>
                        <p className="text-sm text-slate-500 mt-3">Items per component: <span className="font-semibold">{itemsPerComponent}</span> (4s per item)</p>
                    </div>
                </div>

                <div className="px-6 py-4 bg-slate-50 rounded-b-lg flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 border-2 border-slate-300 rounded-lg text-slate-600 hover:border-slate-400 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onStart(minutes)}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                    >
                        Start Mock Test
                    </button>
                </div>
            </div>
        </div>
    );
}


